import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/Header.css';

import { ThemeContext } from '../context/ThemeContext';
import { useDemo } from '../context/DemoContext';
import useAuthState from '../hooks/useAuthState';

const Header = () => {
    const { theme } = useContext(ThemeContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuthenticated, isLoading } = useAuthState();
    const { isDemoMode, exitDemoMode } = useDemo();

    const handleBack = () => {
        navigate(-1); // Go back in browser history
    };

    // Show back button on all pages except the main feed
    const showBackButton = location.pathname !== '/posts';
    
    // Get theme-specific back arrow icon
    const getBackArrowIcon = () => {
        return theme === 'dark' ? '/images/back-arrow-dark.svg' : '/images/back-arrow-light.svg';
    };
    const getFPLogoIcon = () => {
        return theme === 'dark' ? '/images/fp-icon-dark.svg' : '/images/fp-icon-light.svg';
    };

    if (isLoading) {
        return (
            <header className="App-header">
                {showBackButton && (
                    <button className="back-button" onClick={handleBack} aria-label="Go back">
                        <img src={getBackArrowIcon()} alt="Back" className="back-icon" />
                    </button>
                )}
                <div className="header-center">
                    <img src={getFPLogoIcon()} alt="Logo" className="header-logo" />
                </div>
                <div className="header-buttons">
                    <span>Loading authentication status...</span>
                </div>
            </header>
        );
    }

    return (
        <header className="App-header">
            {showBackButton && (
                <button className="back-button" onClick={handleBack} aria-label="Go back">
                    <img src={getBackArrowIcon()} alt="Back" className="back-icon" />
                </button>
            )}
            <div className="header-center">
                <img src={getFPLogoIcon()} alt="Logo" className="header-logo" />
            </div>
            <div className="header-buttons">
                {!isAuthenticated && (
                    <>
                        <button className="signup-button" onClick={() => {
                            // localStorage.setItem('redirectAfterAuth', location.pathname);
                            navigate('/signup');
                        }}>Sign Up</button>
                        <button className="login-button" onClick={() => {
                            // localStorage.setItem('redirectAfterAuth', location.pathname);
                            navigate('/login');
                        }}>Login</button>
                    </>
                )}
                {isAuthenticated && (
                    <>
                        {isDemoMode && (
                            <button className="exit-demo-button" onClick={() => {
                                // exitDemoMode();
                                navigate('/');
                            }}>
                                Exit Demo
                            </button>
                        )}
                        <div className="hamburger-icon">
                            <img src={theme === 'dark' ? '/images/hamburger-dark.svg' : '/images/hamburger-light.svg'} 
                                 alt="Menu" className="hamburger-image" />
                        </div>
                    </>
                )}
            </div>
        </header>
    );
};

export default Header;
